<template>
  <div class="spinner" :class="'my-' + margin">
    <div class="spinner__item bounce1" />
    <div class="spinner__item bounce2" />
    <div class="spinner__item bounce3" />
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    margin: {
      type: String,
      default: '3'
    }
  }
};
</script>

<style lang="scss" scoped>
.spinner {
  margin: 3rem auto;
  width: 70px;
  text-align: center;

  &__item {
    width: 18px;
    height: 18px;
    background-color: $primary;

    border-radius: 100%;
    display: inline-block;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }
}

.spinner .bounce1 {
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  animation-delay: -0.16s;
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
</style>
